<template>
  <div
    :class="{ 'is-disabled': disabled }"
    class="rt-collapse-item"
    :style="{'margin': contentMargin}"
  >
    <div
      class="header"
      :class="[headerBgColorClass]"
      @click="handleHeaderClick"
    >
      <div class="rt-header-content">
        <template v-if="isLeft">
          <div class="icon-margin icon-left">
            <span
              v-if="iconName"
              class="icon-button"
            >{{ iconName }}</span>
            <rt-icon
              :class="{ 'is-active': isActive, 'is-left': isLeft }"
              :color="SCSS_VARIABLES.COLOR_INFO"
              class="arrow"
              :name="buttonIconName"
              size="16"
            />
          </div>
          <slot name="title">
            {{ title }}
          </slot>
          <div class="icon-margin">
            <slot name="handle">
            </slot>
          </div>
        </template>
        <template v-else>
          <slot name="title">
            <span
              class="panel-header"
              :class="{ 'header-large-padding': headerLargePadding }"
            >{{ title }}</span>
          </slot>
          <div class="icon-margin">
            <slot name="handle">
              <span
                v-if="iconName"
                class="icon-button"
              >{{ iconName }}</span>
              <rt-icon
                :class="{ 'is-active': isActive }"
                :color="SCSS_VARIABLES.COLOR_INFO"
                class="arrow"
                :name="buttonIconName"
                size="16"
              />
            </slot>
          </div>
        </template>
      </div>
    </div>
    <el-collapse-transition>
      <div
        v-show="isActive"
        class="content-wrap"
        :class="[contentBgColorClass, { border }]"
      >
        <div
          class="content"
          :class="{ 'content-large-padding': contentLargePadding }"
          :style="{ 'padding': contentPadding}"
        >
          <slot />
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon.vue';
export default {
  name: 'RtCollapseItem',
  components: { RtIcon },
  props: {
    title: String,
    name: [String, Number],
    disabled: Boolean,
    /**
     * @public 带文字按钮
     */
    iconName: {
      type: String,
      default: ''
    },
    /**
     * @public 支持显示边框线
     */
    border: {
      type: Boolean,
      default: false
    },
    /**
     * @public 支持图标位置在左侧
     */
    position: {
      type: String,
      default: 'left'
    },
    /**
     * @public 支持设置header背景色
     */
    headerBgColor: {
      type: String,
      default: 'white'
    },
    /**
     * @public 支持设置content背景色
     */
    contentBgColor: {
      type: String,
      default: 'white'
    },
    /**
     * @public 自定义header的padding
     */
    headerLargePadding: {
      type: Boolean,
      default: false
    },
    /**
     * @public 自定义header的padding
     */
    contentLargePadding: {
      type: Boolean,
      default: false
    },
    /**
     * @public 自定义图标
     */
    buttonIconName: {
      type: String,
      default: 'rt-base-arrow-right-lined'
    },
    contentPadding: {
      type: String,
      default: undefined
    },
    contentMargin: {
      type: String,
      default: undefined
    }
  },
  inject: ['collapse'],
  computed: {
    isActive () {
      return this.collapse.activeNames.indexOf(this.name) > -1;
    },
    isLeft () {
      return this.position === 'left';
    },
    headerBgColorClass () {
      return 'header-bg-' + this.headerBgColor;
    },
    contentBgColorClass () {
      return 'content-bg-' + this.contentBgColor;
    }
  },
  methods: {
    handleHeaderClick () {
      if (this.disabled) return;
      this.$parent.handleItemClick(this.name);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCollapseItem.vue?2d933886